import { captureMessage } from '@sentry/nextjs';
import { config } from 'config';
import { CartItemInput } from 'contexts/type/cart-type';
import type { SubscriptionElement } from 'interfaces/cart';
import type { PdProductItem } from 'interfaces/line-item';

export interface EffectiveCartSubscriptionItem extends SubscriptionElement {
  items: PdProductItem[];
}

export interface AssertNoNullVariantIdArgs {
  items: CartItemInput[];
  context: {
    cart: unknown;
    url?: string;
    logger?: Pick<Console, 'error'>;
  };
}

/**
 * Checks if there is any variants with null in variantId
 */
export function assertNoNullVariantId({ items, context }: AssertNoNullVariantIdArgs): void {
  if (!items.some((item) => item.variantId === null)) return;

  const {
    cart,
    url = typeof window !== 'undefined' ? window.location.href : '',
    logger = console,
  } = context;

  const { branchName, pdEnv } = config;

  try {
    captureMessage('variantId error', {
      level: 'error',
      extra: {
        url,
        cart: JSON.stringify(cart),
      },
      tags: {
        branchName,
        environment: pdEnv,
      },
    });
  } catch (error) {
    logger.error(error);
  }

  throw new Error('variantId is null');
}

/**
 * Checks if value is empty. Is needed to define and remove empty data from the product
 */
export const isValueEmpty = (value: unknown): boolean => {
  return value === undefined || value === null || value === '';
};
